import React from 'react';
import Content from './components/Content';
import './App.css';

function App() {
  return (
    <div className="App">
      <Content />
    </div>
  );
}

export default App;
